<template>
  <div
    class="order-status c:col-center"
    :class="{
      hidden: data.hidden,
      'no-title': !data.title,
      'no-desc': !data.desc,
    }"
    :style="{
      '--bg-color': data.bgColor,
      '--desc-color': data.descColor,
    }"
  >
    <div>
      <div v-if="data.title" class="order-status-title">{{ data.title }}</div>
      <div v-if="data.subtitle" class="order-status-subtitle">
        {{ data.subtitle }}
      </div>
    </div>
    <div v-if="data.withTimer" class="order-status-desc">
      <span v-if="data.descPrefix" class="before-timer">{{
        data.descPrefix
      }}</span
      ><TimeCutDown
        :to="data.timingTo"
        :type="data.timingType"
        :color="data.timingType === 'duration' ? 'inherit' : '#ED7867'"
        @finish="$emit('timeup')"
      /><span class="after-timer" :class="[data.timingType]">{{
        data.desc
      }}</span>
    </div>
    <div v-else-if="data.desc" class="order-status-desc">
      {{ data.desc }}
    </div>
  </div>
</template>

<script>
import TimeCutDown from "@/components/common/TimeCutDown.vue";
import { formatDuration, getAdjustPriceStatus } from "@/utils";
import { mapGetters, mapState } from "vuex";

export default {
  components: { TimeCutDown },
  props: {
    order: Object,
    isBaseOrder: Boolean,
    isCreator: Boolean,
    refundStatus: Object,
  },
  mounted() {},
  computed: {
    ...mapState(["brandInfo"]),
    ...mapGetters(["runInWeChat"]),
    data() {
      const data = {
        hidden: false,
        bgColor: "#fff",
        title: "",
        withTimer: false,
        descPrefix: "",
        timingTo: 0,
        timingType: "datetime", // 'datetime' | 'duration'
        desc: "",
        subtitle: "",
        descColor: "#000",
      };

      if (this.refundStatus.isRefundAll) {
        data.subtitle = "已退款";
      } else if (this.refundStatus.isRefunding) {
        data.subtitle = "退款中";
      } else {
        data.subtitle = "";
      }
      return this.setData(data);
    },
  },
  methods: {
    setData(data) {
      switch (this.order.status) {
        case 0: // 待转发
          return this.setData_WaitTransfer(data);

        case 10: // 待付款
          return this.setData_WaitPay(data);

        case 20: // 重置物流中
          return this.setData_ResetLogistics(data);

        case 30: // 待发货
          return this.setData_Paid(data);

        case 40: // 待提货
          return this.setData_Pickup(data, "待提货");

        case 50: // 待收货
          return this.setData_Pickup(data, "待收货");

        case 60: // 已完成
          return this.setData_Complete(data);

        case 70: // 已取消
          return this.setData_Canceled(data);

        case 80: // 待完成
          if (this.isBaseOrder) {
            data.hidden = true;
          } else {
            data.bgColor = "#f7f7f7";
            if (this.runInWeChat) {
              data.title = "已支付";
            } else {
              data.title = "待完成";
            }
          }
          break;

        default:
          data.hidden = true;
          break;
      }

      return data;
    },
    // 待转发
    setData_WaitTransfer(data) {
      const adjustPriceStatus = getAdjustPriceStatus(this.order);
      // if (adjustPriceStatus.rejected > 0) {
      //   data.bgColor = "#f7f7f7";
      //   data.title = "已驳回";
      //   data.desc = `驳回原因：${adjustPriceStatus.rejectRemark}`;
      //   data.descColor = "#ED7867";
      // } else
      if (adjustPriceStatus.pending > 0) {
        data.bgColor = "#f7f7f7";
        data.title = "调价审核中";
        data.desc = "";
      } else {
        if (this.isCreator) {
          data.hidden = true;
        } else {
          data.bgColor = "#f7f7f7";
          data.title = "待分享";
        }
      }
      return data;
    },
    // 待付款
    setData_WaitPay(data) {
      if (this.brandInfo.orderExpiry?.enabled) {
        const timingTo = this.$moment(
          this.order.submitTime || this.order.createdDate
        ).add(this.brandInfo.orderExpiry.expiryTime, "s");
        if (timingTo.isAfter(this.$moment())) {
          data.withTimer = true;
          data.desc = "内未付款，您的订单将自动取消";
          data.timingTo = timingTo.valueOf();
          data.timingType = "datetime";
          if (this.runInWeChat) {
            data.bgColor = "#fff";
            data.title = "";
            return data;
          }
        } else {
          return this.setData_Canceled(data);
        }
      }

      data.bgColor = "#f7f7f7";
      data.title = "待支付";
      return data;
    },
    // 重置物流中
    setData_ResetLogistics(data) {
      if (this.isBaseOrder) {
        data.bgColor = "#f7f7f7";
        data.title = "物流已重置";
        if (this.runInWeChat) {
          data.desc = "请您重新选择提货方式";
        } else {
          data.desc = "待客人重新选择提货方式";
        }
      } else {
        data.hidden = true;
      }
      return data;
    },
    // 已支付
    setData_Paid(data) {
      data.bgColor = "#f7f7f7";
      if (this.isBaseOrder) {
        data.title = "待发货";
        data.desc = "";
      } else {
        data.hidden = true;
      }
      return data;
    },
    // 待提货/待收货
    setData_Pickup(data, title) {
      console.log("setData_Pickup", this.isBaseOrder);
      if (this.isBaseOrder) {
        data.bgColor = "#f7f7f7";
        data.title = title;
        if (this.order.status === 50) {
          console.log("待收货");
          const timingTo = this.order.autoReceiveSecond
            ? this.$moment().add(this.order.autoReceiveSecond, "s")
            : null;
          if (this.runInWeChat && timingTo) {
            console.log("待自动确认", timingTo);
            data.withTimer = true;
            data.descPrefix = "还剩";
            data.desc = "自动确认";
            data.timingTo = timingTo.valueOf();
            data.timingType = "duration";
          } else {
            data.desc = "";
          }
        } else {
          data.desc = "";
        }
      } else {
        data.hidden = true;
      }
      return data;
    },
    // 已完成
    setData_Complete(data) {
      data.bgColor = "#f7f7f7";
      if (this.isBaseOrder) {
        data.title = "已完成";
        data.desc = "";
      } else {
        if (this.runInWeChat) {
          data.title = "已支付";
        } else {
          data.title = "已完成";
        }
      }
      return data;
    },
    // 已取消
    setData_Canceled(data) {
      data.bgColor = "#f7f7f7";
      data.title = "已取消";
      if (this.brandInfo.orderExpiry?.enabled) {
        data.desc = `订单超过${formatDuration(
          this.brandInfo.orderExpiry.expiryTime
        )}未支付，订单已自动取消`;
      }
      return data;
    },
  },
};
</script>

<style lang="less" scoped>
.order-status {
  --bg-color: #fff;

  gap: 10/20rem;

  width: 100%;
  height: auto;
  background-color: var(--bg-color);

  padding: 16/20rem 16/20rem;

  &.no-title {
    padding: 23/20rem 16/20rem;
  }

  &.no-desc {
    padding: 19/20rem 16/20rem;
  }

  &.hidden {
    display: none;
  }

  &-title {
    height: 22/20rem;
    line-height: 22/20rem;
    font-weight: 500;
    font-size: 16/20rem;
    text-align: center;
    letter-spacing: 0;
    color: #000;
  }
  &-subtitle {
    height: 18/20rem;
    line-height: 18/20rem;
    font-weight: 500;
    font-size: 12/20rem;
    letter-spacing: 0;
    text-align: center;
    color: var(--desc-color);
  }
  &-desc {
    height: 14/20rem;
    line-height: 14/20rem;
    font-weight: 500;
    font-size: 14/20rem;
    letter-spacing: 0;
    text-align: center;
    color: var(--desc-color);

    .after-timer {
      margin-left: 10/20rem;

      &.duration {
        margin-left: 0;
      }
    }
  }
}
</style>
